'use client';

import { useTranslate } from '@tolgee/react';

export default function NotFound() {
  const { t } = useTranslate();

  return (
    <div>
      <div>{t('page.not-found.title', 'Page Not Found')}</div>
    </div>
  );
}
